import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffectWithPayload } from 'src/infrastructure/saga.helpers'
import { EmailSettingsState, LoginPayload } from './EmailSettingsTypes'

const initialState: EmailSettingsState = {
  email: '',
}

const getUserEmail = justForSideEffectWithPayload()

const login = justForSideEffectWithPayload<LoginPayload>()

const setEmail = (state: EmailSettingsState, action: PayloadAction<string>) => ({ ...state, email: action.payload })

const slice = createSlice({
  name: 'emailSettings',
  initialState,
  reducers: {
    getUserEmail,
    login,
    setEmail,
  },
})

export default slice.reducer

export const { actions } = slice
